import { render, staticRenderFns } from "./PlanosAba.vue?vue&type=template&id=1ffa24e2&scoped=true"
import script from "./PlanosAba.vue?vue&type=script&lang=ts"
export * from "./PlanosAba.vue?vue&type=script&lang=ts"
import style0 from "./PlanosAba.vue?vue&type=style&index=0&id=1ffa24e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffa24e2",
  null
  
)

export default component.exports